import { Component, OnInit, ViewChild } from '@angular/core';
import { DDA, defaultDDA } from '../../interface/dda';
import { FiltroListaDDA } from '../../filter/filtro-lista-dda';
import { PoBreadcrumb, PoDatepickerIsoFormat, PoDialogService, PoLookupColumn, PoModalAction, PoModalComponent, PoPageFilter, PoSearchFilterMode, PoTableAction, PoTableColumn } from '@po-ui/ng-components';
import { Router } from '@angular/router';
import { DDAService } from '../../service/dda.service';
import { AuthService } from 'src/app/service/auth.service';
import { UsuarioLookupService } from 'src/app/service/usuario-lookup-service';
import { FornecedorLookupService } from 'src/app/service/fornecedor-lookup-service';
import { NgForm } from '@angular/forms';
import { UtilService } from 'src/app/service/util';
import { Fornecedor } from 'src/app/interface/fornecedor';

@Component({
  selector: 'app-dda-lista',
  templateUrl: './dda-lista.component.html',
  styleUrl: './dda-lista.component.css'
})
export class DdaListaComponent implements OnInit {

  tabelaPrincipalItens: Array<DDA> = [];
  tabelaPrincipalFiltro: FiltroListaDDA;
  tabelaPrincipalShowMoreDisable: boolean = true;
  tabelaPrincipalHeight: number =  window.innerHeight - 300;
  fornecedorCodigoLoja: string = '';

  DDA: DDA = defaultDDA();

  formatExtended: PoDatepickerIsoFormat = PoDatepickerIsoFormat.Extended;

  poSearchFilterMode: PoSearchFilterMode = PoSearchFilterMode.contains;

  usuarioColumnsFilters: Array<PoLookupColumn> = this.usuarioLookupService.getColumnsFilter();
  fornecedorColumnsFilters: Array<PoLookupColumn> = this.fornecedorLookupService.getColumnsFilter();

  breadcrumb: PoBreadcrumb = {
    items: [
      {label: 'Home', action: this.goHome.bind(this)},
      {label: 'Manutenção DDA'},
    ],
  };

  constructor(
    private router: Router,
    private poDialogService: PoDialogService,
    private DDAService: DDAService,
    private authService: AuthService,
    private utilService: UtilService,
    public usuarioLookupService: UsuarioLookupService,
    public fornecedorLookupService: FornecedorLookupService,
  ) {
    this.tabelaPrincipalFiltro = new FiltroListaDDA(authService,'filtro-lista-manutencao-dda');
  }

  @ViewChild('advancedFilterModal', {static: true}) advancedFilterModal!: PoModalComponent;
  @ViewChild('DDAModal', {static: true}) DDAModal!: PoModalComponent;
  @ViewChild('DDAForm', {static: true}) DDAForm!: NgForm;


  async ngOnInit() {
    this.tabelaPrincipalFiltro.init().then(()=>{
      this.advancedFilterActionModal();
      console.log(window.innerHeight)
    });
  }

  tabelaPrincipalLoad(zerarPaginacao: boolean = true):void{

    if (zerarPaginacao){
      this.tabelaPrincipalFiltro.dados.page = 1;
      this.tabelaPrincipalItens = [];
    } else {
      this.tabelaPrincipalFiltro.dados.page++;
    }

    this.tabelaPrincipalFiltro.postSalvarFiltro();

    this.DDAService.getDDALista(this.tabelaPrincipalFiltro.dados).subscribe({
      next: (lista) => {

        this.tabelaPrincipalShowMoreDisable = !lista.hasNext;

        this.tabelaPrincipalItens = this.tabelaPrincipalItens.concat(lista.items);

       }
    })

  }

  editarDDA(row: DDA): void{

    this.DDA = {...row};
    this.fornecedorCodigoLoja = `${this.DDA.CFIGFORNEC}${this.DDA.CFIGLOJA}`;
    this.DDAModal.open();
  }

  fornecedorSelecionado(fornecedor: Fornecedor):void{
    this.DDA.CFIGFORNEC = fornecedor.CA2COD;
    this.DDA.CFIGLOJA   = fornecedor.CA2LOJA;
    this.DDA.CFIGCNPJ   = fornecedor.CA2CGC;
    this.DDA.CFIGNOMFOR = fornecedor.CA2NREDUZ;
  }

  gravarDDA():void{
    if (this.DDAForm.valid){
      this.poDialogService.confirm({
        title: 'Gravar Alterações',
        message: `Deseja continuar com a gravação das alterações realizadas?`,
        confirm: () => {
          this.DDAService.postDDA(this.DDA).subscribe({
            next: () => {
              this.tabelaPrincipalLoad(true);
            }
          });
        }
      })
    } else {
      this.utilService.showErrosFomulario(this.DDAForm,document);
    }
  }

  async excluirDDA(row: DDA){

    this.poDialogService.confirm({
      title: 'Excluir Registro de DDA',
      message: `Deseja excluir a registro de DDA ?`,
      confirm: () => {
        this.DDAService.deleteDDA(row.NFIGRECNO).subscribe({
          next: () => {
            this.tabelaPrincipalLoad(true);
          }
        });
      }
    })
  }

  loadDDA(row: DDA):void{
    this.DDAService.getDDA(row.NFIGRECNO).subscribe({
      next: (retorno) => {
        this.DDA = retorno;
      }
    })
  }

  public readonly tabelaPrincipalColunas: Array<PoTableColumn> = [
    {property: 'DFIGDATA'  , label: 'Emissão'     , width: '10%', visible: true, type: 'date'},
    {property: 'CFIGFORNEC', label: 'Fornecedor'  , width: '10%', visible: true},
    {property: 'CFIGLOJA'  , label: 'Loja'        , width: '06%', visible: false},
    {property: 'CFIGNOMFOR', label: 'Razão Social', width: '30%', visible: true},
    {property: 'CFIGTITULO', label: 'Código'      , width: '12%', visible: true},
    {property: 'CFIGTIPO'  , label: 'Esp Tít DDA' , width: '10%', visible: true},
    {property: 'DFIGVENCTO', label: 'Dt Vencto'   , width: '10%', visible: true, type: 'date'},
    {property: 'NFIGVALOR' , label: 'Vl Título'   , width: '12%', visible: true, type: 'currency', format: 'BRL'},
    {property: 'CFIGCONCIL', label: 'Conciliado'  , width: '08%', visible: true, type: 'label',
      labels: [
        {value: '1', label: 'Sim', color: 'color-10'},
        {value: '2', label: 'Não', color: 'color-07'},
      ]
    },
    {property: 'DFIGDTCONC', label: 'Conciliação' , width: '08%', visible: false, type: 'date'},
    {property: 'CFIGUSCONC', label: 'Usr Conc DDA', width: '08%', visible: false},
    {property: 'CFIGDDASE2', label: 'Tít Rel SE2' , width: '15%', visible: true},
    {property: 'CFIGCNPJ'  , label: 'CNPJ/CPF'    , width: '08%', visible: false},
  ]

  public tabelaPrincipalActions: Array<PoTableAction> = [
    { label: 'Editar'  , action: this.editarDDA.bind(this),    icon: 'po-icon-edit' },
    { label: 'Excluir' , action: this.excluirDDA.bind(this),   icon: 'po-icon-delete' },
  ]

  goHome(): void {
    this.router.navigateByUrl('');
  }

  //################################################################//
  // FILTRO
  //################################################################//
  public readonly filterSettings: PoPageFilter = {
    advancedAction: this.advancedFilterActionModal.bind(this),
  };

  advancedFilterActionModal(): void {
    this.advancedFilterModal.open();
  }

  public readonly advancedFilterPrimaryAction: PoModalAction = {
    action: () => {
      this.advancedFilterModal.close();
      this.tabelaPrincipalLoad(true);
    },
    label: 'Aplicar Filtros'
  };

}

